import { RequestError, } from './RequestError';
/**
 * Zurich Api Gateway (WSO2) responded with an error.
 *
 * Normally thrown in the data service!
 */
export class ApiGatewayError extends RequestError {
    static className = 'ApiGatewayError';
    constructor(props) {
        super(props);
    }
}
